import SeoHead from "@/Component/Seo/SeoHead";
import NotFound from "@/Component/Module/NotFound";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";

export default function NotFoundRoutePage({ seoCountry }) {
  return (
    <>
      <SeoHead
        fallbackTitle="Page not found | Next Holidays"
        country={seoCountry}
        noIndex
      />
      <NotFound />
    </>
  );
}

export async function getServerSideProps(context) {
  const country = getCountryFromContext(context);
  return {
    props: {
      seoCountry: country === "IN" ? "IN" : "UAE",
    },
  };
}
